/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_fiat_v2/vendor';
import 'stylesheets/showroom_fiat_v2/vendor';
